var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"audio"},[(_vm.src)?_c('audio',{ref:"audio",attrs:{"src":_vm.src,"autoplay":"","loop":_vm.loop},on:{"ended":_vm.ended,"error":_vm.error}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }